import React from 'react';
import styled from 'styled-components';
import MDTLogo from 'src/assets/images/MedtronicWhite.svg';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import EngineeringwhiteDesktop from 'src/assets/images/EngineeringwhiteDesktop.svg';
import Logout2 from 'src/assets/images/Logout2.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import {
    Container,
    ImageContainer,
    Image,
    Wrapper,
    Header,
    Logo,
    ErrorTitle,
    ErrorMessage,
    ErrorDetails as SharedErrorDetails,
    ButtonText,
} from './SsoErrorCommon.styled';

const GenericErrorPage = ({ errorMessage }) => {
    const { instance } = useMsal();
    const { t } = useTranslation();

    const handleRetry = () => {
        window.location.reload();
    };

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        instance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin,
        });
    };

    return (
        <Container>
            <ImageContainer>
                <Image src={EngineeringwhiteDesktop} alt={t('ssoError.errorImageAlt')} />
            </ImageContainer>
            <Wrapper>
                <Header>
                    <Logo src={MDTLogo} alt={t('ssoError.medtronicLogoAlt')} />
                </Header>
                <ErrorTitle>{t('ssoError.authenticationErrorTitle')}</ErrorTitle>
                <ErrorMessage>
                    {t('ssoError.authenticationErrorMessage')}
                </ErrorMessage>
                {errorMessage && (
                    <ErrorDetails>
                        <strong>{t('ssoError.errorDetailsLabel')}</strong> {errorMessage}
                    </ErrorDetails>
                )}
                <ErrorDetails>
                    {t('ssoError.authenticationErrorDetails')}
                </ErrorDetails>
                <ButtonContainer>
                    <Button
                        id={'genericerror-retry-button'}
                        show={true}
                        width={'119px'}
                        height={'36px'}
                        margin={'20px 15px 0 0'}
                        backgroundColor={'#28a745'}
                        color={'#ffffff'}
                        border={'1px solid #ffffff'}
                        clicked={handleRetry}
                    >
                        <ButtonText>{t('ssoError.tryAgainButton')}</ButtonText>
                    </Button>
                    <Button
                        id={'genericerror-logout-button'}
                        show={true}
                        width={'119px'}
                        height={'36px'}
                        margin={'20px 0 0 0'}
                        backgroundColor={'#140f4b'}
                        color={'#ffffff'}
                        border={'1px solid #ffffff'}
                        clicked={handleLogout}
                    >
                        <div style={{ margin: '5px 10px 0 5px', cursor: 'pointer' }}>
                            <img src={Logout2} alt={t('ssoError.logoutIconAlt')} />
                        </div>
                        <ButtonText>{t('ssoError.logoutButton')}</ButtonText>
                    </Button>
                </ButtonContainer>
            </Wrapper>
        </Container>
    );
};

export default GenericErrorPage;
const ErrorDetails = styled(SharedErrorDetails)`
    margin: 0 0 12px 0;
    word-break: break-word;

    strong {
        color: #ffad00;
        font-family: 'AvenirNextWorld Regular', Arial, sans-serif;
    }

`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: 8px;
    flex-wrap: wrap;
`;

